import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramInsurersPage } from './program-insurers';
import { MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramInsurersPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramInsurersPage),
    MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule
  ],
})
export class ProgramInsurersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-insurers/program-insurers.module.ts